<template>
  <div class="menu">
    <div class="menu_top">
      <div class="logo">
        <img class="logo_icon" :src="logoIcon" />
        <p class="logo_text">{{ careRings }}</p>
      </div>
    </div>
    <div class="menu_list" :style="{height: menuListHeight}">
      <ul class="menu_list_navigations">
        <li class="menu_list_nav" @click="setActive">
          <menuBar
            :icon="corporationIcon"
            :title="corporations"
            :path="corporationLink"
          ></menuBar>
        </li>
        <li class="menu_list_nav" @click="setActive">
          <menuBar
            :icon="commonIcon"
            :title="common"
            :path="commonLink"
          ></menuBar>
        </li>
        <li class="menu_list_nav" @click="setActive">
          <menuBar
            :icon="mailHistoryIcon"
            :title="mailHistory"
            :path="mailHistoryLink"
          ></menuBar>
        </li>
        <li class="menu_list_nav" @click="setActive">
          <menuBar
            :icon="notificationIcon"
            :title="notification"
            :path="notificationLink"
          ></menuBar>
        </li>
        <li
          id="menu_maintenance"
          class="menu_list_nav"
          @click="showConfirmModalMaintenance = true"
        >
          <div class="menu_bar router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="maintenanceIcon" />
              {{ maintenance }}
            </div>
          </div>
        </li>
        <li
          id="menu_forced_update"
          class="menu_list_nav"
          @click="showConfirmModalForcedUpdate = true"
        >
          <div class="menu_bar router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="forcedUpdateIcon" />
              {{ forcedUpdate }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="modal_window" v-if="showConfirmModalMaintenance">
      <confirmCustomTitleModalWindow
        :title="confirmModalTitleMaintenance"
        :question="confirmModalQuestionMaintenance"
        @close="close"
        @ok="toMaintenance"
      >
      </confirmCustomTitleModalWindow>
    </div>
    <div class="modal_window" v-if="showConfirmModalForcedUpdate">
      <confirmCustomTitleModalWindow
        :title="confirmModalTitleForcedUpdate"
        :question="confirmModalQuestionForcedUpdate"
        @close="close"
        @ok="toForcedUpdate"
      >
      </confirmCustomTitleModalWindow>
    </div>
    <menuBottom></menuBottom>
  </div>
</template>

<script>
import menuBottom from './menubottom.vue'
import menuBar from './menubar.vue'
import confirmCustomTitleModalWindow from './modalWindow/confirmCustomTitleModalWindow.vue'

export default {
  data() {
    return {
      logoIcon: require('../../../img/logo.png'),
      careRings: 'CareRings Sys.',
      corporations: 'テナント一覧',
      common: 'テナント共通設定',
      mailHistory: 'メール送信履歴',
      notification: 'お知らせ',
      maintenance: 'メンテナンス',
      forcedUpdate: '強制アップデート',
      confirmModalTitleMaintenance: 'メンテナンス画面',
      confirmModalQuestionMaintenance:
        'メンテナンス予定の確認、追加、削除等を行う画面です。<br/>メンテナンス画面を開きますか？',
      confirmModalTitleForcedUpdate: '強制アップデート画面',
      confirmModalQuestionForcedUpdate:
        '有効なアプリの最低バージョンを更新する画面です。<br/>強制アップデート画面を開きますか？',
      corporationIcon: require('../../../img/dashboard.png'),
      commonIcon: require('../../../img/device.png'),
      mailHistoryIcon: require('../../../img/mailHistory.png'),
      notificationIcon: require('../../../img/registerNotification.png'),
      maintenanceIcon: require('../../../img/maintenance.png'),
      forcedUpdateIcon: require('../../../img/forcedUpdate.png'),
      corporationLink: '/master/corporations',
      commonLink: '/master/common',
      mailHistoryLink: '/master/mailHistory',
      notificationLink: '/master/notification',
      maintenanceLink: '/master/maintenance',
      forcedUpdateLink: '/master/forcedUpdate',
      windowHeight: '',
      showConfirmModalMaintenance: false,
      showConfirmModalForcedUpdate: false
    }
  },
  computed: {
    menuListHeight() {
      const otherHeight = 108
      return this.windowHeight - otherHeight + 'px'
    }
  },
  components: {
    menuBottom,
    menuBar,
    confirmCustomTitleModalWindow
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    setActive(e) {
      var li = e.currentTarget.parentNode.querySelectorAll('li')
      for (var i = 0; i < li.length; i++) {
        li[i].className = 'menu_list_nav'
      }
      e.currentTarget.className = 'active'
    },
    setActiveAfterConfirm(e) {
      var li = e.parentNode.querySelectorAll('li')
      for (var i = 0; i < li.length; i++) {
        li[i].className = 'menu_list_nav'
      }
      e.className = 'active'
    },
    toMaintenance() {
      this.showConfirmModalMaintenance = false
      let element = document.getElementById('menu_maintenance')
      this.setActiveAfterConfirm(element)
      this.$router.push('/master/maintenance')
    },
    toForcedUpdate() {
      this.showConfirmModalForcedUpdate = false
      let element = document.getElementById('menu_forced_update')
      this.setActiveAfterConfirm(element)
      this.$router.push('/master/forcedUpdate')
    },
    close() {
      this.showConfirmModalMaintenance = false
      this.showConfirmModalForcedUpdate = false
    }
  }
}
</script>
<style scoped>
.active {
  font-size: 0;
}
.menu_top {
  background-color: #33ccff;
}
.menu_list {
  background-color: #bbffff;
}
.active .router {
  background-color: #a7f1ff;
}
:not(.active).menu_list_nav .router {
  background-color: #bbffff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/menulist.vue